import { StyleLayer } from '../style_layer';
import properties from './raster_style_layer_properties.g';
export class RasterStyleLayer extends StyleLayer {
    constructor(layer) {
        super(layer, properties);
    }
}
//# sourceMappingURL=raster_style_layer.js.map